"use client";

import Skeleton from "@/components/atoms/skeletons";
import React, { useState, useEffect, useRef } from "react";

interface LazyComponentProps {
    children: React.ReactNode;
    id?: string
}

const LazyComponent: React.FC<LazyComponentProps> = ({ children, id }) => {
    const [isVisible, setIsVisible] = useState(false);
    const ref = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                }
            },
            { threshold: 0.1 }
        );

        if (ref.current) {
            observer.observe(ref.current);
        }

        return () => {
            if (ref.current) {
                observer.unobserve(ref.current);
            }
        };
    }, []);

    return (
        <div
            id={id}
            ref={ref}
            className={`fade-in ${isVisible ? "visible" : ""}`}
            style={{ minHeight: 200 }}
        >
            {isVisible ? children : <Skeleton />}
        </div>
    );
};

export default LazyComponent;
